import { HostelSorting, ResponseData, SelectedOption, AppSortingState } from '@/Interfaces/AppSorting'
import axios from 'axios'
import { ref } from 'vue'

export const sortCriteria = ref('')

export const updateSortCriteria = (criteria: string): void => {
    sortCriteria.value = criteria
}

export const getSortedItems = ({ state }: { state: AppSortingState }, ...callbacks: Array<(data: ResponseData) => void>): void => {
    axios
        .get(`${ state.url }${ state.listing.id }?sortBy=${ state.sortedBy }&search=${ state.searchString }&page=${ state.currentPage }`)
        .then((response) => {
            callbacks.forEach(callback => callback(response.data))
        })
        .catch((error) => {
            console.error('Error fetching sorted items:', error)
        })
}

export const mockHostelSorting = ref<HostelSorting>({
    options: {
        ratingLatest: {
            key: 'ratingLatest',
            title: 'Latest reviews',
            sortBy: 'commentDate'
        },
        ratingHighest: {
            key: 'ratingHighest',
            title: 'Highest reviews',
            sortBy: 'ratingDesc'
        },
        ratingLowest: {
            key: 'ratingLowest',
            title: 'Lowest reviews',
            sortBy: 'rating'
        }
    },
    selected: {
        sortBy: 'commentDate',
        type: 'commentDate',
        title: 'Latest reviews'
    }
})

export const changeSelectedMockHostelSorting = (selected: SelectedOption): void => {
    mockHostelSorting.value.selected = selected
}
